import React, {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Select,{createFilter} from 'react-select'
import {envAwarePost,dateToAPIStandard,envAwareFormSubmit} from '../../util/util'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import {
	newMessageScheduled,
	selectScheduledMessageById,
	editScheduledMessage
} from '../../state/messengerSlice'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import DatePicker from "react-datepicker"
import FileButton from '../FileButton/FileButton'
import MemoRecorder from '../MemoRecorder/MemoRecorder'
import {toggleShow as toggleShowMemoRecorder} from '../MemoRecorder/slice'
import useCurrentUser from '../../hooks/useCurrentUser'
import "react-datepicker/dist/react-datepicker.css"

const mapItemsToSelectObjects = (items,type) => items.map( item =>({
	label:type === 'tag' ? item.name : item.user_name,
	value:type === 'tag' ? item.id : item.user_id_number
}))//end map

const mapUsersToId = users => users.map(user=>user.user_id_number)

const MessageEditor = ({clients,trainers=[],onCancel,tags}) =>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const messageData = useSelector(state=>{
		const messageId = state.messenger.editor.messageId
		return selectScheduledMessageById(state,messageId)
	})
	const [status,setStatus] = useState('idle')
	const tagSpecsIds = [2,4]
	const [specifyByTag,setSpecifyByTag] = useState(tagSpecsIds.includes(messageData.specification_id))
	const [matchExactly,setMatchExactly] = useState(messageData.specification_id === 2)
	const [recipientSpecification,setRecipientSpecification] = useState([])
	const [message,setMessage] = useState(messageData.message)
	const [messageAll,setMessageAll] = useState(
		Boolean(messageData.send_to_all)
		|| messageData.specification_id === 5
		|| messageData.specification_id === 6
	)
	const [messageAllClients,setMessageAllClients] = useState(false)
	const [messageAllTrainers,setMessageAllTrainers] = useState(false)

	const [deleteAttachment,setDeleteAttachment] = useState(false)
	const [date,setDate] = useState(new Date(messageData?.send_at?.split(' ').join('T')))

	const [startDate,setStartDate] = useState(new Date(messageData?.schedule.start?.split(' ').join('T')))
	const [endDate,setEndDate] = useState(new Date(messageData?.schedule.end?.split(' ').join('T')))
	const [repeat,setRepeat] = useState(messageData?.schedule.freq)
	const [interval,setInterval] = useState(1)
	const [weekDays,setWeekDays] = useState(messageData?.schedule.week_days)
	const [isRecurring,setIsRecurring] = useState(Boolean(messageData?.schedule.is_recurring))

	//memo related state
	const [isMemo,setIsMemo] = useState(messageData.is_memo)
	const [memo,setMemo] = useState(null)
	const [memoType,setMemoType] = useState(null)

	useEffect(()=>{
		setRecipientSpecification(
			specifyByTag ?
			messageData.tags.map(t=>({label:t.name,value:t.id})) :
			messageData.recipients.map(r=>({label:r.user_name,value:r.user_id_number}))
		)
		setMessage(messageData.message)
		setDate(new Date(messageData.send_at?.split(' ').join('T')))
		setMessageAll(Boolean(messageData.send_to_all))
		setIsMemo(Boolean(messageData.isMemo))
		setMessageAll(
			Boolean(messageData.send_to_all)
			|| messageData.specification_id === 5
			|| messageData.specification_id === 6
			|| messageData.specification_id === 3
		)
		if (messageData.specification_id === 5) {
			setMessageAllTrainers(true)
		}
		if (messageData.specification_id === 3) {
			setMessageAllClients(true)
		}
		if(messageData.specification_id === 6) {
			setMessageAllTrainers(true)
			setMessageAllClients(true)
		}
	},[messageData])

	console.log(messageData)

	const user = useCurrentUser()
	const isGym = user.account_type === 'gym'

	const {
		file:attachment,
		processUpload,
		setUpload,
		clearUpload
	} = useS3DirectUpload()

	const updateHandler = async(e)=>{
		setStatus('loading')
		const postData = {
			action:'editScheduledMessage',
			id:messageData.id,
			is_memo:Number(isMemo),
			update:{
				message:message
			},
			schedule:{
				//for backend purposes daily is used for 
				//single occurance events 
				freq:repeat==='none'?'daily':repeat,
				//non-repeating or single weekly repeates can only 
				//have interval = 1
				interval:repeat==='none'||repeat==='weekly'?1:interval,
				start:dateToAPIStandard(startDate),
				end:isRecurring?'forever':dateToAPIStandard(endDate),
				week_days:weekDays,
				is_recurring:repeat==='none'?0:Number(isRecurring)
			}
		}
		if(Boolean(isMemo)){
			postData.memo = memo
			postData.transcode_memo_to_mp4 = 1
			postData.media_type_id = memoType === 'video' ?  1 : 4
		}
		if(Boolean(attachment)){
			const uploadRes = await processUpload()
			if(uploadRes.success) postData.new_attachment = uploadRes.payload.url
		}
		if(deleteAttachment) postData.new_attachment = ''
		if(messageAll&&!specifyByTag){
			//only all trainers
			if(messageAllTrainers&&!messageAllClients){
				postData.update.specification_id = 5
			} 
			//all trainers and all clients
			else if(messageAllClients&&messageAllTrainers){
				postData.update.specification_id = 6
			} 
			//only all clients
			else {
				postData.update.specification_id = 3
			}
		}else if(specifyByTag){
			postData.update.tag_ids = recipientSpecification.map(s=>s.value)
			if(matchExactly){
				postData.update.specification_id = 2
			}else{
				postData.update.specification_id = 4
			}
		}else{
			postData.update.specification_id = 1
			postData.update.recipient_ids = recipientSpecification.map(s=>s.value)
		}

		statusDispatch(editScheduledMessage(postData),'message','edit')
		.then(() => {
			setStatus('idle')
			handleClearAttachment()
			onCancel(e, true)
		})
	}

	//helper function for adding/removing a day from the 
	//array of repeat weekdays
	const toggleWeeklyDayString = (day) => {
		if (weekDays.includes(day)) {
			setWeekDays(weekDays.filter(d => d !== day))
		} else {
			setWeekDays([...weekDays, day])
		}
	}

	const handleToggleMemoRecorder = ()=>{
		dispatch(toggleShowMemoRecorder())
	}

	const handleFinishMemo =  memoData => {
		setIsMemo(true)
		setMemo(memoData.memo)
		setMemoType(memoData.type)
	}

	const handleClearAttachment = ()=>{
		clearUpload()
		setIsMemo(false)
		setMemo(null)
		setMemoType(null)
	}

	//if specifying user by tag the items
	//in the select should be tags otherwise 
	//the items should be the users
	const selectOptions = (
		specifyByTag 
		? mapItemsToSelectObjects(tags,'tag') 
		: (
			trainers.length > 0 
			? [
				{
					label:'Trainers',
					options:mapItemsToSelectObjects(trainers,'user') 
				},
				{
					label:'Clients',
					options:mapItemsToSelectObjects(clients,'user') 
				},
			]
			:mapItemsToSelectObjects(clients,'user') 
		)
	)
	return (
		<div>
			<MemoRecorder handleFinish={handleFinishMemo}/>
			<div className="mb-2">
				<div className="d-flex justify-content-between mb-2">
					<small>Search clients/tags or select all</small>
					<div className="d-flex align-items-center" style={{fontSize:'14px'}}>
						<span className="mr-2">specify recipients by:</span>
						<label className="m-0 mr-2">
							<input 
								name="edit_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(false)}
								checked={!specifyByTag}
							/> Name
						</label>
						<label className="m-0">
							<input 
								name="edit_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(true)}
								checked={specifyByTag}
							/> Tag
						</label>
					</div>
				</div>
				<div className="d-flex cancelDrag">
					<Select
						filterOption={createFilter({ matchFrom: "start" })}
						className="w-100"
						isDisabled={messageAll}
						isMulti
						value={messageAll?[]:recipientSpecification}
						options={selectOptions}
						onChange={(selectedClients)=>{
							//to prevent toggling to all selecting all from 
							if(!messageAll){
								setRecipientSpecification(selectedClients)
							}
						}}
						noOptionsMessage={()=>(
							messageAll?'Sending to all':'Select...'
						)}
						/>
					{!specifyByTag&&
						<OverlayTrigger
							placement="left"
							overlay={
								<Tooltip>
									Send to all clients
								</Tooltip>
							}
						>
							<Button
								variant={messageAll?"primary":"outline-secondary"}
								className="ml-2"
								onClick={()=>{
									//clear out all recipients for editting
									setRecipientSpecification([])
									setMessageAll(!messageAll)
								}}>
								All
							</Button>
						</OverlayTrigger>
					}
				</div>
				{specifyByTag&&
					<Form.Check
						className="mt-1"
						checked={matchExactly}
						id="exact-tag-match-toggle-edit"
						label="Only include clients that have ALL of the selected tags"
						onChange={e=>{setMatchExactly(e.target.checked)}}
					/>
				}
			</div>
			{(messageAll&&!specifyByTag&&isGym)&&
				<div className="d-flex justify-content-around pt-2">
					<Form.Check 
						onChange={e=>{
							setMessageAllClients(e.target.checked)
						}}
						checked={messageAllClients}
						id="all-clients-check"
						label="All Clients"
					/>
					<Form.Check 
						onChange={e=>{
							setMessageAllTrainers(e.target.checked)
						}}
						checked={messageAllTrainers}
						id="all-trainers-check"
						label="All Trainers"
					/>
				</div>
			}
			<Form.Control 
				as="textarea"
				value={message}
				style={{whiteSpace:'pre-wrap'} }
				name="messageText"
				id="messageText"
				onChange={e=>setMessage(e.target.value)}
				placeholder="Write a message"
			/>
			<div className="d-flex pt-1">
				{(Boolean(messageData.attachment)&&!Boolean(attachment)&&!Boolean(memo))&&
					<>
						{!deleteAttachment&&
							(messageData.media_type_id === 2 ?
								<img 
									style={{
										maxWidth:'120px',
										maxHeight:'120px',
										objectFit:'scales',
										borderRadius:'8px',
										marginRight:'4px'
									}} 
									src={messageData.attachment}
								/>
								:
								<video
									controls 
									style={{
										maxWidth:'120px',
										maxHeight:'120px',
										objectFit:'scales',
										borderRadius:'8px',
										marginRight:'4px'
									}} 
									src={messageData.attachment}
								/>
							)
						}
						<div>
							<Button 
								onClick={()=>{setDeleteAttachment(!deleteAttachment)}} 
								variant={deleteAttachment?"outline-success":"outline-danger"} 
								size="sm"
							>
								{deleteAttachment?'Keep attachment':'Remove'}
							</Button>
						</div>
					</>
				}
				{Boolean(attachment)&&
					<>
						<img 
							style={{
								maxWidth:'120px',
								maxHeight:'120px',
								objectFit:'scales',
								borderRadius:'8px',
								marginRight:'4px'
							}} 
							src={URL.createObjectURL(attachment)}
						/>
						<div>
							<small className="d-block">{attachment.name}</small>
							<Button onClick={clearUpload} variant="outline-danger" size="sm">
								{Boolean(messageData.attachment)?'Undo':'Remove'}
							</Button>
						</div>
					</>
				}
				{Boolean(memo)&&
					<>
						<video
							controls 
							style={{
								maxWidth:'120px',
								maxHeight:'120px',
								objectFit:'scales',
								borderRadius:'8px',
								marginRight:'4px'
							}} 
							src={URL.createObjectURL(memo)}
						/>
						<div>
							<small className="d-block">{memo.name}</small>
							<Button onClick={handleClearAttachment} variant="outline-danger" size="sm">
								{Boolean(messageData.attachment)?'Undo':'Remove'}
							</Button>
						</div>
					</>
				}
			</div>
			<div className="d-flex justify-content-end mt-2">
				<OverlayTrigger overlay={
					<Tooltip>Add attachment</Tooltip>
				}>
					<FileButton 
						onChange={e=>{
							setUpload(e.target.files[0])
						}} 
						className="mr-auto"
					/>
				</OverlayTrigger>
				<OverlayTrigger overlay={
					<Tooltip>
						Record a voice/video memo
					</Tooltip>
				}>
					<Button 
						className="text-dark"
						onClick={handleToggleMemoRecorder}
						disabled={status ===  'loading'} 
						variant="link"
					>
						<i className="fa fa-microphone"/> / <i className="fa fa-video"/>
					</Button>
				</OverlayTrigger>
			</div>
			<div>
				<Form.Control 
					onChange={e=>{
						const val = e.target.value
						setRepeat(val)
						if(val==='none'){
							setIsRecurring(false)
							setEndDate(startDate)
						}
					}}
					value={repeat} 
					as="select" 
					custom
				>
					<option value="none">No Repeat</option>
					<option value="daily">Daily</option>
					<option value="weekly">Weekly</option>
				</Form.Control>
				{repeat==='daily'&&
					<div>
						<small>Repeat every</small>
						<Form.Control 
							onChange={e=>{
								setInterval(e.target.value)
							}}
							value={interval}
							placeholder="number of days"
						/>
					</div>
				}
				{repeat==='weekly'&&
					<div className="d-flex justify-content-around">
						{['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
							<Form.Check
								checked={weekDays.includes(d.toLowerCase())}
								onChange={()=>{
									toggleWeeklyDayString(d.toLowerCase())
								}}
								id={`weekly-${d}`}
								label={d}
							/>
						))}
					</div>
				}
				<div className='mt-2'>
					<div className="d-flex justify-content-between flex-wrap">
						<div>
							{repeat!=='none'&&
								<small className="d-block">Start Date</small>
							}
							<DatePicker
								onChangeRaw={e=>{e.preventDefault()}}
								selected={startDate}
								onChange={date=>{
									setStartDate(date)
									if (repeat==='none') setEndDate(date)
								}}
								showTimeSelect
								timeIntervals={15}
								dateFormat="MMM d, yy @ h:mm aa"
								minDate={new Date()}
								popperModifiers={{
									preventOverflow: {
										enabled: true,
										escapeWithReference: false,
										boundariesElement: 'viewport'
									}
								}}
								popperProps={{
									positionFixed: true
								}}
								customInput={<Form.Control/>}
							/>
							{(repeat!=='none')&&
								<Form.Check 
									onChange={e=>{
										setIsRecurring(e.target.checked)
										if(!e.target.checked) setEndDate(startDate)
									}}
									id="no-end-date-check"
									checked={isRecurring}
									label="No End Date"
								/>
							}
						</div>
						{(repeat!=='none'&&!isRecurring)&&
							<div>
								<small className="d-block">End Date</small>
								<DatePicker
									onChangeRaw={e=>{e.preventDefault()}}
									selected={endDate}
									onChange={date=>setEndDate(date)}
									dateFormat="MMM d, yy"
									minDate={startDate}
									popperModifiers={{
										preventOverflow: {
											enabled: true,
											escapeWithReference: false,
											boundariesElement: 'viewport'
										}
									}}
									popperProps={{
										positionFixed: true
									}}
									customInput={<Form.Control/>}
								/>
							</div>
						}
					</div>
				</div>
			</div>
			<hr className="my-2"/>
			<div className="d-flex justify-content-end">
				<OverlayTrigger overlay={
					<Tooltip>
						Cancel
					</Tooltip>
				}>
					<Button 
						className="text-danger"
						onClick={onCancel}
						disabled={status ===  'loading'} 
						variant="link"
					>
						Cancel
					</Button>
				</OverlayTrigger>
				<Button
					variant="link"
					className="text-info"
					disabled={
						status === 'loading' ||
						!message ||
						(!recipientSpecification.length && !messageAll)
					}
					onClick={updateHandler}>
					{
						status ===  'idle' ?
						<i className="fas fa-save"/>
						:
						<Spinner animation="border" role="status" size="sm">
							<span className="sr-only">Loading...</span>
						</Spinner>
					}
				</Button>
			</div>
			<div className="text-right mt-1">
				<small>Can only be scheduled on 15 minute intervals <i className="fa fa-info-circle"/> </small>
			</div>
		</div>
	)
}

export default MessageEditor